import * as React from 'react';
import { Modal, UIHeading4, UIHeading6 } from '@cian/ui-kit';
import { IconActionClose12 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './ContactsModalV2.css';

interface IContactsModalV2Props {
  handleClose: () => void;
  open: boolean;
  phone: string;
}

export const ContactsModalV2 = ({ handleClose, open, phone }: IContactsModalV2Props): React.JSX.Element => {
  return (
    <Modal
      data-testid="ContactsModal"
      closeButtonProps={{
        theme: 'fill_light',
        title: 'Закрыть',
        icon: <IconActionClose12 color="icon-secondary-default" />,
      }}
      open={open}
      onOpenChange={handleClose}
      size="S"
    >
      <div data-testid="ContactsModalContent" className={styles['content']}>
        <UIHeading6 color="text-secondary-default">Контакты консультанта</UIHeading6>
        <span className={styles['contacts']} data-testid="ContactPhone">
          {phone}
        </span>
        <UIHeading4>Режим работы с&nbsp;09:00 до&nbsp;21:00 по&nbsp;Москве</UIHeading4>
      </div>
    </Modal>
  );
};
